<template>
  <div class="my_datepicker">
    <vue-datepicker-local
      v-model="startDate"
      format="YYYY-MM-DD"
      clearable
      :local="local"
      :disabled-date="disabledStartDate"
      @confirm="startConfirm"
      @cancel="startCancel"
      @clear="startClear"
      placeholder="Start Date"
      show-buttons
    ></vue-datepicker-local>
    <span class="interval">to</span>
    <vue-datepicker-local
      v-model="endDate"
      format="YYYY-MM-DD"
      clearable
      :local="local"
      class="end_date"
      :disabled-date="disabledEndDate"
      @confirm="endConfirm"
      @cancel="endCancel"
      @clear="endClear"
      placeholder="End Date"
      show-buttons
    ></vue-datepicker-local>
  </div>
</template>

<script>
import VueDatepickerLocal from "vue-datepicker-local";
export default {
  components: {
    VueDatepickerLocal,
  },
  props: ["startTime", "endTime"],
  data() {
    return {
      startDate: "",
      endDate: "",
      local: {
        dow: 0, // Sunday is the first day of the week
        hourTip: "Select Hour", // tip of select hour
        minuteTip: "Select Minute", // tip of select minute
        secondTip: "Select Second", // tip of select second
        yearSuffix: "", // suffix of head year
        monthsHead: "January_February_March_April_May_June_July_August_September_October_November_December".split(
          "_"
        ), // months of head
        months: "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), // months of panel
        weeks: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), // weeks,
        cancelTip: "cancel",
        submitTip: "confirm",
      },
    };
  },
  methods: {
    //开始时间控制范围
    disabledStartDate(time) {
      if (this.endDate === "" || this.endDate !== "") {
        let endDateVal = 1561910461 * 1000;
        if (endDateVal) {
          return (
            time.getTime() < 1561910461 * 1000 ||
            time.getTime() > new Date(this.endDate).getTime()
          );
        }
      } else {
        let endDateVal = this.endDate;
        if (endDateVal) {
          return time.getTime() > new Date(endDateVal).getTime();
        }
      }
    },
    //结束时间的控制范围
    disabledEndDate(time) {
      if (this.startDate === "") {
        let beginDateVal = 1561910461 * 1000;
        if (beginDateVal) {
          return time.getTime() < 1561910461 * 1000;
        }
      } else {
        let beginDateVal = this.startDate;
        if (beginDateVal) {
          return time.getTime() < new Date(beginDateVal).getTime();
        }
      }
    },
    //开始时间
    startConfirm() {
      this.$emit("startConfirm", this.startDate);
    },
    //结束时间
    endConfirm() {
      this.$emit("endConfirm", this.endDate);
    },
    //取消开始时间
    startCancel() {
      this.$emit("startCancel");
    },
    endCancel() {
      this.$emit("endCancel");
    },
    startClear() {
      this.$emit("startClear");
    },
    endClear() {
      this.$emit("endClear");
    },
  },
  watch: {
    startTime: {
      handler(newValue) {
        this.startDate = newValue;
      },
      immediate: true,
      deep: true,
    },
    endTime: {
      handler(newValue) {
        this.endDate = newValue;

        // this.endDate = newValue;
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>

<style scoped>
.datepicker {
  width: 45%;
}
.datepicker:before {
  left: 0;
  display: block;
}
.datepicker >>> .datepicker-popup {
  z-index: 9999;
}
.my_datepicker >>> .datepicker > input {
  padding: 0 0px 0 30px !important;
  border-radius: 4px;
}
.interval {
  padding: 0 5px;
  font-size: 14px;
}
.end_date {
  position: relative;
}
.end_date >>> .datepicker-popup {
  left: -60px !important;
  z-index: 9999;
}
.datepicker >>> .calendar-date-selected,
.calendar-date-selected:hover {
  background: #409eff;
  color: #fff;
  font-weight: inherit;
}
.datepicker >>> .datepicker__buttons .datepicker__button-select {
  background: #409eff;
  border-radius: 5px;
}
.datepicker >>> .datepicker__buttons .datepicker__button-cancel {
  background: #c8c8c8;
  border-radius: 5px;
}
@media screen and (max-width: 320px) {
  .end_date >>> .datepicker-popup {
    left: -80px !important;
  }
}
</style>
